//站点系统
const stationSystemZh = {
  staSysLang: {
    请输入站点名称搜索: '请输入站点名称搜索',
    暂无数据: '暂无数据',
    主机: '主机',
    从机: '从机',
    未知: '未知',
    请输入系统名称搜索: '请输入系统名称搜索',
    重置统计: '重置统计',
    远程控制: '远程控制',
    能量管理: '能量管理',
    当前站点系统: '当前站点系统',
    已离线: '已离线',
    最后数据时间: '最后数据时间',
    实时数据: '实时数据',
    今日充电量: '今日充电量',
    今日放电量: '今日放电量',
    累计充电量: '累计充电量',
    累计放电量: '累计放电量',
    电池堆: '电池堆 ',
    告警状态: '告警状态',
    表示当前站点系统的设备告警状态告警内容为运维处理内容: '表示当前站点系统的设备告警状态，告警内容为运维处理内容。',
    进入设备监控: '进入设备监控',
    名称: '名称',
    状态: '状态',
    离线: '离线',
    告警: '告警',
    正常: '正常',
    禁止放电: '禁止放电',
    取消: '取消',
    确定: '确定',
    重置统计: '重置统计',
    开始时间: '开始时间',
    选择日期时间: '选择日期时间',
    时区: '时区',
    请选择时区偏移: '请选择时区偏移',
    请选择时间: '请选择时间'
  },
  energyManage: {
    //能量管理
    站点系统: '站点系统',
    能量管理: '能量管理',
    远程控制: '远程控制',
    本地控制: '本地控制',
    指EMS禁止本地控制: '指EMS禁止本地控制。',
    指EMS禁止远程控制: '指EMS禁止远程控制。',
    调试方式: '调试方式',
    仅支持在本地屏进行控制模式变更: '仅支持在本地屏进行控制模式变更。',
    智慧控制: '智慧控制',
    手动能量控制: '手动能量控制',
    能量控制: '能量控制',
    BMS并网控制: 'BMS并网控制',
    防过载: '防过载',
    防逆流: '防逆流',
    余量功率: '余量功率',
    手动控制: '手动控制',
    二级保护: '二级保护'
  },

  //智慧控制--智慧策略
  energyCommand: {
    能量控制参数由平台根据智慧能量管理算法生成请确保系统额定容量与额定功率数值真实准确: '能量控制参数由平台根据智慧能量管理算法生成，请确保系统“额定容量”与“额定功率”数值真实准确。',
    智慧策略: '智慧策略',
    使用中: '使用中',
    待机中: '待机中',
    停用中: '停用中',
    时区: '时区',
    额定容量: '额定容量',
    额定功率: '额定功率',
    启用: '启用',
    当前策略: '当前策略',
    历史策略: '历史策略',
    日期: '日期',
    选择日期: '选择日期',
    人工: '人工',
    通过智慧算法生成: '通过智慧算法生成',
    查看详情: '查看详情',
    充电: '充电',
    放电: '放电',
    待机: '待机',
    计划功率: '计划功率',
    时间: '时间',
    当前暂无策略: '当前暂无策略',

    //智慧控制--人工策略
    开始时间: '开始时间',
    选择时间: '选择时间',
    结束时间: '结束时间',
    执行储能控制类别: '执行储能控制类别',
    请输入功率: '请输入功率',
    暂无数据: '暂无数据',
    提示: '提示',
    新增: '新增',
    请确认是否启用智慧控制启用后将会停止人工控制策略进入待机状态直到新的智慧控制策略下发: '请确认是否启用智慧控制，启用后将会停止人工控制策略，进入待机状态，直到新的智慧控制策略下发！',
    请确认是否启用人工控制启用后智慧控制策略将会被停用: '请确认是否启用人工控制，启用后智慧控制策略将会被停用！',
    否: '否',
    是: '是',

    请选择开始时间: '请选择开始时间',
    开始时间不可与结束时间相同: '开始时间不可与结束时间相同',
    选择结束时间: '选择结束时间',
    结束时间不可与开始时间相同: '结束时间不可与开始时间相同',
    请选择类别: '请选择类别',
    请输入计划功率: '请输入计划功率',
    时间段存在冲突请重新配置: '时间段存在冲突请重新配置',
    请确认是否应用能量控制参数: '请确认是否应用能量控制参数！',
    应用: '应用',
    取消: '取消'
  },

  powerControl: {
    //手动能量控制
    设置参数后需点击应用按钮方可执行无充电或放电操作的时间段将执行待机操作: '设置参数后，需点击“应用”按钮方可执行。无充电或放电操作的时间段，将执行待机操作！',
    开始时间: '开始时间',
    选择时间: '选择时间',
    结束时间: '结束时间',
    执行储能控制类别: '执行储能控制类别',
    充电: '充电',
    放电: '放电',
    待机: '待机',
    计划功率: '计划功率',
    请输入功率: '请输入功率',
    计划SOC: '计划SOC',
    请输入计划SOC: '请输入计划SOC',
    暂无数据: '暂无数据',
    新增: '新增',
    取消: '取消',
    应用: '应用',
    请选择开始时间: '请选择开始时间',
    开始时间不可与结束时间相同: '开始时间不可与结束时间相同',
    选择结束时间: '选择结束时间',
    结束时间不可与开始时间相同: '结束时间不可与开始时间相同',
    请选择类别: '请选择类别',
    请输入计划功率: '请输入计划功率',
    时间段存在冲突请重新配置: '时间段存在冲突,请重新配置',
    请确认是否应用能量控制参数: '请确认是否应用能量控制参数！',
    当前页面参数已调整请确认是否要放弃修改: '当前页面参数已调整，请确认是否要放弃修改？',
    是否放弃修改: '是否放弃修改？',
    放弃: '放弃'
  },
  powerControlHy: {
    //华友能量控制
    能量控制策略应用月份需满足12个月点击页面底部应用按钮下发后方可执行: '能量控制策略应用月份需满足 12 个月，点击页面底部“应用”按钮下发后，方可执行。',
    已满12个月无法新建策略: '已满12个月无法新建策略。',
    新建策略: '新建策略',
    应用月份: '应用月份',
    操作人: '操作人',
    操作: '操作',
    查看: '查看',
    编辑: '编辑',
    已满12个月无法引用: '已满12个月无法引用。',
    请确认是否删除该策略: '请确认是否删除该策略？',
    删除: '删除',
    暂无数据: '暂无数据',
    取消: '取消',
    应用月份未满12个月请新建策略: '应用月份未满12个月请新建策略！',
    已满12个月可点击应用按钮下发执行: '已满12个月可点击应用按钮下发执行！',
    应用: '应用',
    查看详情: '查看详情',
    月: '月',
    开始时间: '开始时间',
    结束时间: '结束时间',
    对应时段: '对应时段',
    最大充电功率: '最大充电功率',
    最大放电功率: '最大放电功率',
    尖: '尖',
    峰: '峰',
    平: '平',
    谷: '谷',
    确定: '确定',

    站点系统: '站点系统',
    编辑策略: '编辑策略',
    应用月份选择: '应用月份选择',
    月份支持一次选择多个选择完成后在下方填写所选月份的能量控制参数: '月份支持一次选择多个，选择完成后在下方填写所选月份的能量控制参数。',
    该月份在其他策略中已选择: '该月份在其他策略中已选择。',
    月份: '月份',
    能量控制参数: '能量控制参数',
    为选择的月份设置参数后需点击确定按钮: '为选择的月份设置参数后，需点击“确定”按钮。',
    开始时间: '开始时间',
    结束时间: '结束时间',
    请选择: '请选择',
    请输入: '请输入',
    暂无数据: '暂无数据',
    新增: '新增',
    确定: '确定',
    一月: '1月',
    二月: '2月',
    三月: '3月',
    四月: '4月',
    五月: '5月',
    六月: '6月',
    七月: '7月',
    八月: '8月',
    九月: '9月',
    十月: '10月',
    十一月: '11月',
    十二月: '12月',
    请选择时间: '请选择时间',
    请选择时间段类型: '请选择时间段类型！',
    请输入最大充电功率: '请输入最大充电功率！',
    请输入最大放电功率: '请输入最大放电功率！',
    是否放弃修改: '是否放弃修改？',
    当前页面参数已调整请确认是否要放弃修改: '当前页面参数已调整，请确认是否要放弃修改？',
    放弃: '放弃',
    请选择配置月份: '请选择配置月份！',
    请配置能量控制参数: '请配置能量控制参数！'
  },

  //防过载
  preventOverload: {
    设置参数时请按照禁充阈值大于限充阈值大于启动阈值填写: '设置参数时，请按照 “禁充阈值 > 限充阈值 > 启动阈值” 填写！',
    防过载设置: '防过载设置',
    防过载功能: '防过载功能',
    使能: '使能',
    禁能: '禁能',
    禁充阈值: '禁充阈值',
    限充阈值: '限充阈值',
    启动阈值: '启动阈值',
    请输入: '请输入',
    暂无数据: '暂无数据',
    取消: '取消',
    应用: '应用',
    请输入限充阈值: '请输入限充阈值',
    请输入启动阈值: '请输入启动阈值',
    请输入禁充阈值: '请输入禁充阈值',
    '请确认是否启用防过载功能？': '请确认是否启用防过载功能？',
    提示: '提示',
    是: '是',
    否: '否',
    '请确认是否禁用防过载功能？': '请确认是否禁用防过载功能？',
    请按照禁充阈值大于限充阈值大于启动阈值填写: '请按照 “禁充阈值 > 限充阈值 > 启动阈值” 填写！',
    请确认是否应用防过载参数: '请确认是否应用防过载参数！',
    是否放弃修改: '是否放弃修改？',
    当前页面参数已调整请确认是否要放弃修改: '当前页面参数已调整，请确认是否要放弃修改？',
    放弃: '放弃'
  },

  //防逆流
  preventReflux: {
    设置参数时请按照启动阈值大于限放阈值大于禁放阈值填写: '设置参数时，请按照 “启动阈值 > 限放阈值 > 禁放阈值” 填写！',
    防逆流设置: '防逆流设置',
    防逆流功能: '防逆流功能',
    使能: '使能',
    禁能: '禁能',
    启动阈值: '启动阈值',
    限放阈值: '限放阈值',
    禁放阈值: '禁放阈值',
    请输入: '请输入',
    暂无数据: '暂无数据',
    取消: '取消',
    应用: '应用',
    请输入启动阈值: '请输入启动阈值',
    请输入限放阈值: '请输入限放阈值',
    请输入禁放阈值: '请输入禁放阈值',
    '请确认是否启用防逆流功能？': '请确认是否启用防逆流功能？',
    提示: '提示',
    是: '是',
    否: '否',
    '请确认是否禁用防逆流功能？': '请确认是否禁用防逆流功能？',
    请按照启动阈值大于限放阈值大于禁放阈值填写: '设置参数时，请按照 “启动阈值 > 限放阈值 > 禁放阈值” 填写！',
    请确认是否应用防逆流参数: '请确认是否应用防逆流参数！',
    是否放弃修改: '是否放弃修改？',
    当前页面参数已调整请确认是否要放弃修改: '当前页面参数已调整，请确认是否要放弃修改？',
    放弃: '放弃'
  },
  //余量功率
  marginPower: {
    余量功率设置时请将参数控制在变压器容量的百分之五至百分之二十之间: '余量功率设置时，请将参数控制在变压器容量的5%～20%之间。',
    余量功率设置: '余量功率设置',
    变压器容量: '变压器容量',
    变压器信息: '变压器信息',
    充电余量: '充电余量',
    数值范围: '数值范围',
    放电余量: '放电余量',
    EMS使能: 'EMS使能',
    使能: '使能',
    禁能: '禁能',
    暂无数据: '暂无数据',
    取消: '取消',
    应用: '应用',
    数字范围: '数字范围',
    整数: '整数',
    请选择: '请选择',
    请输入充电余量: '请输入充电余量',
    请输入放电余量: '请输入放电余量',
    提示: '提示',
    请确认是否应用余量功率参数: '请确认是否应用余量功率参数！',
    是否放弃修改: '是否放弃修改？',
    当前页面参数已调整请确认是否要放弃修改: '当前页面参数已调整，请确认是否要放弃修改？',
    放弃: '放弃'
  },

  //手动控制
  manualControl: {
    并网控制: '并网控制',
    PCS控制: 'PCS控制',
    控制设置: '控制设置',
    当前状态: '当前状态',
    控制模式: '控制模式',
    手动: '手动',
    控制类别: '控制类别',
    充电: '充电',
    放电: '放电',
    待机: '待机',
    计划功率: '计划功率',
    自动: '自动',
    请输入: '请输入',
    控制参数: '控制参数',
    跟随能量控制: '跟随能量控制',
    调整控制模式: '调整控制模式',
    跟随能量控制自动配置: '跟随能量控制自动配置',
    应用: '应用',
    '下发“并网/离网”指令后，请“开启/断开”市电网电路！': '下发“并网/离网”指令后，请“开启/断开”市电网电路！',
    离网运行: '离网运行',
    取消: '取消',
    确定: '确定',
    请输入计划功率: '请输入计划功率',
    提示: '提示',
    '请确认是否下发PCS运行/停机指令！': '请确认是否下发PCS运行/停机指令！',
    PCS运行: 'PCS运行',
    PCS停机: 'PCS停机',
    请确认是否应用: '请确认是否应用？'
  },
  //二级保护
  secondaryProtection: {
    二级保护设置: '二级保护设置',
    当前参数: '当前参数',
    SOC上限: 'SOC上限',
    SOC下限: 'SOC下限',
    放电截止电压: '放电截止电压',
    充电截止电压: '充电截止电压',
    过放释放电压: '过放释放电压',
    过充释放电压: '过充释放电压',
    二级保护参数设置: '二级保护参数设置',
    请输入: '请输入',
    应用: '应用',
    请输入SOC上限: '请输入SOC上限',
    请输入SOC下限: '请输入SOC下限',
    请输入放电截止电压: '请输入放电截止电压',
    请输入充电截止电压: '请输入充电截止电压',
    请输入过放释放电压: '请输入过放释放电压',
    小数点后不允许超过3位: '小数点后不允许超过3位',
    '请确认是否应用二级保护参数？': '请确认是否应用二级保护参数？',
    提示: '提示',
    取消: '取消'
  }
}
export default stationSystemZh
